import type {LucideIcon} from "lucide-react";
import type {ReactNode} from "react";
import {Card, CardContent, CardHeader} from "@/components/ui/card";
import {cn} from "@/lib/utils";

type Props = {
  label: string;
  value: ReactNode;
  hint?: string;
  icon?: LucideIcon;
  tone?: "default" | "accent";
};

export function AdminStatCard({label, value, hint, icon: Icon, tone = "default"}: Props) {
  return (
    <Card className={cn("border-border/70 shadow-sm", tone === "accent" && "border-primary/15 bg-gradient-to-br from-primary/[0.04] to-transparent")}>
      <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-2">
        <p className="text-sm font-medium text-muted-foreground">{label}</p>
        {Icon ? (
          <div className={cn("admin-dash-icon", tone === "accent" && "admin-dash-icon--accent")}>
            <Icon className="h-4 w-4" />
          </div>
        ) : null}
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-semibold tracking-tight text-foreground">{value}</div>
        {hint ? <p className="mt-1.5 text-xs text-muted-foreground">{hint}</p> : null}
      </CardContent>
    </Card>
  );
}
